import { render, staticRenderFns } from "./MyClosedNotifications.vue?vue&type=template&id=08bf04e2"
import script from "./MyClosedNotifications.vue?vue&type=script&lang=js"
export * from "./MyClosedNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports